import { render, staticRenderFns } from "./SinistreDetail.vue?vue&type=template&id=4b046664&"
import script from "./SinistreDetail.vue?vue&type=script&lang=js&"
export * from "./SinistreDetail.vue?vue&type=script&lang=js&"
import style0 from "./SinistreDetail.vue?vue&type=style&index=0&id=4b046664&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports